export interface DeliveryTask {
  id: string;
  routeHistoryId: number;
  routeName: string;
  originalDriverId?: string;
  driverAccountId: number;
  pathPlanningTaskId?: number;
  driverTaskId?: number;
  areaId?: number;
  areaName?: string;
  warehouseId?: number;
  dspId?: number;
  taskDate?: string;
  status: string;
  assignedParcels?: number;
  actualPickedUpParcels?: number;
  transferInParcels?: number;
  transferOutParcels?: number;
  estimatedDistanceKm?: number;
  estimatedDurationMinutes?: number;
  createdBy?: number;
  createdByName?: string;
  createdAt?: string;
  updatedAt?: string;
  // 详情页字段
  originalDriverName?: string;
  actualDriverName?: string;
  taskHistory?: TaskHistoryType[];
  parcels?: ParcelType[];
  // 分组字段（后端返回树状结构时使用）
  isGroupRow?: boolean;
  children?: DeliveryTask[];
  totalTasks?: number;
  totalAssignedParcels?: number;
  totalActualPickedUp?: number;
  // 实际需要派送的包裹数量（排除转出的包裹）
  actualTotalParcels?: number;
  workIndex?: string;
}

export interface TaskHistoryType {
  id: string;
  eventType: string;
  dataJson?: string;
  operatedBy: number;
  operatedByName?: string;
  createdAt: string;
  description?: string;
}

// 包裹状态枚举
export enum ParcelPickupStatus {
  NOT_PICKED_UP = 'NOT_PICKED_UP',
  PICKED_UP = 'PICKED_UP',
  TRANSFERRED_OUT = 'TRANSFERRED_OUT',
  TRANSFERRED_IN = 'TRANSFERRED_IN'
}

// 包裹状态颜色映射
export const ParcelPickupStatusColor = {
  [ParcelPickupStatus.NOT_PICKED_UP]: 'default',      // 未扫描：灰色
  [ParcelPickupStatus.PICKED_UP]: 'success',          // 已扫描：绿色
  [ParcelPickupStatus.TRANSFERRED_OUT]: 'error',     // 转出：红色
  [ParcelPickupStatus.TRANSFERRED_IN]: 'warning'      // 转入：橙色
} as const;

export interface ParcelType {
  id: string;
  trackingNo: string;
  zipcode: string;
  stop: number;
  subStopNumber?: string;
  pickupStatus: ParcelPickupStatus;
  status: string;
}

export interface TimeRange {
  start: string;
  end: string;
}

export interface DeliveryTaskFilter {
  warehouseId?: number;
  taskDateStart?: string;
  taskDateEnd?: string;
  publishDate?: TimeRange;
  areaId?: number;
  status?: DeliveryTaskStatus[];
  dspId?: number;
  driverIds?: number[];
  taskIds?: string; // 批量任务ID查询，支持换行符、逗号、空格分隔
}

export enum DeliveryTaskStatus {
  NONE = 'NONE', // 无状态，兼容旧数据中的 null 值
  CREATED = 'CREATED',
  DRIVER_PICKINGUP = 'DRIVER_PICKINGUP',
  DELIVERING = 'DELIVERING',
  COMPLETED = 'COMPLETED'
}

export interface PageRequest {
  page: number;
  size: number;
  sortBy?: string;
  sortDirection?: 'ASC' | 'DESC';
}

export interface DeliveryTaskListResponse {
  content: DeliveryTask[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export interface Driver {
  id: string;
  accountId: number;
  name: string;
  phone: string;
  driverLicenseNumber: string;
  vehiclePlate: string;
  isBlacklist: boolean;
  isOnDuty: boolean;
  dspId?: number;
  status?: number; // 账户状态：0=禁用，1=启用
  isEmployed?: boolean; // 是否在职：false=离职，true=在职
  verificationStatus?: number; // 实名验证状态：2=已实名
}